module.exports = __webpack_public_path__ + "img/netherlands.ae455f7f.png";